import React, { Suspense } from 'react';
import { Router } from 'react-router';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider as ApolloProviderHooks } from '@apollo/client';
import { UserContextProvider } from '@blocs.auth';
import { FeatureExperimentProvider } from '@blocs.features-experiments';
import { MaintenanceGuard } from '@blocs.maintenance';
import { AppKey, InternationalizationProvider } from '@blocs.i18n';
import { Loading } from '@minecraft.loader';
import { NotificationProvider } from '@minecraft.notification-provider';
import { EnterpriseTheme } from '@minecraft.themes';
import Routes from 'src/routes';
import routerHistory from 'utils/router-history';
import { getEnvironment } from '@minecraft.environment';
import { WindowWidthContext } from '@minecraft.utils';
import { GoogleOAuthProvider } from '@react-oauth/google';
import createApolloClient from '../lib/init-apollo';

const App = (): JSX.Element => {
  const environment = getEnvironment();
  const apolloClient = createApolloClient();

  return (
    <Suspense fallback={<Loading />}>
      <InternationalizationProvider appName={AppKey.REPS} namespaces={['reps']}>
        <FeatureExperimentProvider>
          <Router history={routerHistory}>
            <ApolloProviderHooks client={apolloClient}>
              <GoogleOAuthProvider clientId={environment.GOOGLE_AUTH_CLIENT_ID}>
                <UserContextProvider>
                  <ThemeProvider theme={EnterpriseTheme}>
                    <NotificationProvider>
                      <MaintenanceGuard routes={Routes} />
                    </NotificationProvider>
                  </ThemeProvider>
                </UserContextProvider>
              </GoogleOAuthProvider>
            </ApolloProviderHooks>
          </Router>
        </FeatureExperimentProvider>
      </InternationalizationProvider>
    </Suspense>
  );
};

export default WindowWidthContext.withWidthDataProvider(React.memo(App));
